export default {
  nav: {
    home: 'Home',
    about: 'About',
    menu: 'Menu',
    gallery: 'Gallery',
    hours: 'Hours',
    contact: 'Contact',
    order: 'Order Now',
    book: 'Book a Table',
    cart: 'Your Order',
  },
  hero: {
    badge: 'Open 24 Hours Every Day',
    title1: 'Taste the Spirit of',
    highlight: 'India',
    title2: 'Any Hour You Wish',
    subtitle:
      'Authentic Indian cuisine from chaat to tandoor, served day and night. Dine in our warm rooftop, or have it delivered to your door — whenever the craving hits.',
    explore: 'Explore the Menu',
    delivery: 'Order Delivery',
    stat1v: '24/7',
    stat1l: 'Always Open',
    stat2v: '174+',
    stat2l: 'Dishes',
    stat3v: '60 min',
    stat3l: 'Delivery',
  },
  about: {
    eyebrow: 'About Mehfil',
    title: 'A 24/7 Indian Feast in the Heart of Yerevan',
    p1: 'Born from Arman International LLC, Mehfil 24/7 brings the soul of Indian hospitality to Rubinyants Street. "Mehfil" means a warm gathering — and that is exactly what we serve: generous plates, tandoor-fired kebabs, chaat bursting with flavor and a rooftop alive with light.',
    p2: 'Whether it is a late-night paneer tikka, a slow morning masala chai or a family feast that stretches into the night, our kitchen never sleeps. Every dish is made fresh with authentic spices and served with the warmth of home.',
    f1: 'Authentic Tandoor Kitchen',
    f2: 'Real Indian Spices & Recipes',
    f3: 'Fast 24/7 Delivery',
    f4: 'Warm Rooftop Seating',
    cta: 'Visit Us Today',
    badgeV: 'Inder',
    badgeL: 'Owner & Founder',
    owner: 'Meet Inder — the heart and soul behind Mehfil 24/7. Coming from India, he brought his passion for authentic Indian flavors to Yerevan, building a warm space where every guest feels at home. His hands-on approach ensures every dish carries the true warmth of Indian hospitality.',
  },
  menu: {
    eyebrow: 'Our Menu',
    title: '174 Dishes Crafted for Every Hour',
    subtitle:
      'From smoky tandoor to street chaat, pizza, biryani, South Indian classics, sweets and more — 174 dishes served 24/7 for every craving you have.',
    all: 'All',
    add: 'Add to order',
    added: 'Added',
    order: 'Send order',
    request: 'View Your Order',
    cats: {
      tea: 'Tea & Coffee',
      shakes: 'Lassi, Shakes & Juices',
      snacks: 'Snacks',
      chaat: 'Chaat & Desi Cravings',
      starters: 'Chakhna & Starters',
      chinese: 'Chinese',
      raita: 'Raita',
      pizza: 'Pizza / Pasta',
      sweets: 'Sweets',
      mainVeg: 'Main Course Veg',
      nonVeg: 'Non Veg',
      rice: 'Rice',
      breads: 'Breads',
      combo: 'Combo / South Indian',
    },
    items: {
      'ginger-tea': {
        name: 'Ginger Tea',
        desc: 'Warm spiced tea brewed with fresh ginger, cardamom and cinnamon — a classic Indian pick-me-up.',
        tag: '',
      },
      'masala-tea': {
        name: 'Masala Tea',
        desc: 'Aromatic black tea simmered with cardamom, cloves, cinnamon, ginger and milk — the taste of India.',
        tag: 'Popular',
      },
      'plain-tea': {
        name: 'Plain Tea',
        desc: 'Classic Indian black tea brewed to perfection, light and refreshing with a clean finish.',
        tag: '',
      },
      'elaichi-tea': {
        name: 'Elaichi Tea',
        desc: 'Delicate black tea infused with fragrant green cardamom pods, naturally sweet and aromatic.',
        tag: '',
      },
      'lemon-tea': {
        name: 'Lemon Tea',
        desc: 'Refreshing black tea with a bright squeeze of fresh lemon — tangy, soothing and revitalizing.',
        tag: '',
      },
      'black-tea': {
        name: 'Black Tea',
        desc: 'Strong and robust Indian black tea, brewed to a deep copper color — bold and energizing.',
        tag: '',
      },
      'green-tea': {
        name: 'Green Tea',
        desc: 'Light and fragrant green tea with a clean grassy note and subtle sweetness, perfect for any time.',
        tag: '',
      },
      'black-coffee': {
        name: 'Black Coffee',
        desc: 'Rich South Indian filter coffee, dark, bold and full-bodied with a smooth finish.',
        tag: '',
      },
      'milk-coffee': {
        name: 'Milk Coffee',
        desc: 'Smooth and creamy Indian-style coffee with milk, lightly sweetened and perfectly balanced.',
        tag: '',
      },
      'cold-coffee': {
        name: 'Cold Coffee',
        desc: 'Iced cold coffee blended with milk and a touch of sweetness — creamy, refreshing and energizing.',
        tag: '',
      },
      'sweet-lassi': {
        name: 'Sweet Lassi',
        desc: 'Thick and creamy sweetened yogurt drink, blended smooth with a touch of rose — a Punjabi classic.',
        tag: 'Popular',
      },
      'dry-fruit-lassi': {
        name: 'Dry Fruit Lassi',
        desc: 'Rich lassi blended with almonds, pistachios, cashews and saffron — a luxurious, nutty treat.',
        tag: '',
      },
      'salt-lassi': {
        name: 'Salt Lassi',
        desc: 'Savory yogurt drink with roasted cumin and a pinch of salt — cooling and perfectly tangy.',
        tag: '',
      },
      'pudina-lassi': {
        name: 'Pudina Lassi',
        desc: 'Refreshing yogurt drink blended with fresh mint leaves — cool, fragrant and revitalizing.',
        tag: '',
      },
      'banana-milkshake': {
        name: 'Banana Milkshake',
        desc: 'Creamy banana milkshake blended smooth with milk and a hint of vanilla — thick and naturally sweet.',
        tag: '',
      },
      'oreo-shake': {
        name: 'Oreo Shake',
        desc: 'Indulgent milkshake packed with Oreo cookie crumbles, creamy vanilla ice cream and chocolate drizzle.',
        tag: '',
      },
      'chocolate-milkshake': {
        name: 'Chocolate Milkshake',
        desc: 'Rich chocolate milkshake with real cocoa, velvety smooth and topped with chocolate shavings.',
        tag: '',
      },
      'strawberry-milkshake': {
        name: 'Strawberry Milkshake',
        desc: 'Sweet strawberry milkshake made with fresh berries, creamy and naturally pink and refreshing.',
        tag: '',
      },
      'vanilla-milkshake': {
        name: 'Vanilla Milkshake',
        desc: 'Classic vanilla milkshake, thick, creamy and smooth — a timeless favorite for all ages.',
        tag: '',
      },
      'mango-milkshake': {
        name: 'Mango Milkshake',
        desc: 'Tropical mango milkshake with ripe Alphonso mango pulp — rich, golden and irresistibly sweet.',
        tag: 'Popular',
      },
      'dry-fruit-milkshake': {
        name: 'Dry Fruit Milkshake',
        desc: 'Nutty milkshake blended with almonds, cashews and dates — a wholesome, protein-rich treat.',
        tag: '',
      },
      'watermelon-juice': {
        name: 'Watermelon Juice',
        desc: 'Freshly squeezed watermelon juice, cool and naturally sweet — pure summer in a glass.',
        tag: '',
      },
      'orange-juice': {
        name: 'Orange Juice',
        desc: 'Sunshine in a glass — cold-pressed orange juice, bright, tangy and packed with Vitamin C.',
        tag: '',
      },
      'fresh-lime': {
        name: 'Fresh Lime',
        desc: 'Zesty fresh lime drink, sweet and sour with a sparkling fizz — a perfect thirst quencher.',
        tag: '',
      },
      'blue-ocean-mojito': {
        name: 'Blue Ocean Mojito',
        desc: 'A stunning blue mojito with mint, lime and a splash of tropical blue curacao — vibrant and refreshing.',
        tag: '',
      },
      'virgin-mojito': {
        name: 'Virgin Mojito',
        desc: 'A classic non-alcoholic mojito with fresh mint, lime and soda — cool, minty and invigorating.',
        tag: '',
      },
      'lemon-mint': {
        name: 'Lemon Mint',
        desc: 'Cool lemon drink infused with fresh mint leaves — tangy, aromatic and incredibly refreshing.',
        tag: '',
      },
      'veg-samosa': {
        name: 'Veg Samosa',
        desc: 'Crispy golden pastry filled with spiced potatoes and peas, served with tangy tamarind chutney.',
        tag: '',
      },
      'paneer-samosa': {
        name: 'Paneer Samosa',
        desc: 'Flaky samosa stuffed with creamy paneer, herbs and green chilli — rich and satisfying.',
        tag: '',
      },
      'veg-sandwich': {
        name: 'Veg Sandwich',
        desc: 'Grilled vegetable sandwich with cucumber, tomato, onion and mint chutney — fresh and light.',
        tag: '',
      },
      'grilled-cheese-sandwich': {
        name: 'Grilled Cheese Sandwich',
        desc: 'Buttery grilled sandwich loaded with melted cheese, golden and gooey with every bite.',
        tag: '',
      },
      'omelette-sandwich': {
        name: 'Omelette Sandwich',
        desc: 'Fluffy omelette layered between toasted bread with fresh veggies and a hint of spice.',
        tag: '',
      },
      'chicken-tikka-sandwich': {
        name: 'Chicken Tikka Sandwich',
        desc: 'Tandoori chicken tikka stuffed in a toasted bun with mint mayo and crunchy onions — smoky and bold.',
        tag: '',
      },
      'vada-pav': {
        name: 'Vada Pav',
        desc: 'Mumbai-style spiced potato fritter in a soft bun with garlic chutney and fried green chilli.',
        tag: 'Street Style',
      },
      'pav-bhaji': {
        name: 'Pav Bhaji',
        desc: 'Mumbai-famous buttery vegetable mash served with toasted pav buns and a dollop of butter.',
        tag: 'Best Seller',
      },
      'mirchi-vada': {
        name: 'Mirchi Vada',
        desc: 'Whole green chilli stuffed with spiced potato, dipped in batter and fried golden and crisp.',
        tag: 'Spicy',
      },
      'mix-veg-pakora': {
        name: 'Mix Veg Pakora',
        desc: 'Assorted vegetable fritters — onion, potato, cauliflower and spinach — battered and deep-fried.',
        tag: '',
      },
      'paneer-pakora': {
        name: 'Paneer Pakora',
        desc: 'Cubes of fresh paneer coated in spiced gram flour batter, fried crisp and served with chutney.',
        tag: '',
      },
      'bread-pakora': {
        name: 'Bread Pakora',
        desc: 'Bread slices dipped in spiced batter and deep-fried, stuffed with potato — a tea-time favorite.',
        tag: '',
      },
      'egg-pakora': {
        name: 'Egg Pakora',
        desc: 'Hard-boiled egg wrapped in spiced batter and fried to a golden crunch — simple and satisfying.',
        tag: '',
      },
      'bread-egg-omelette': {
        name: 'Bread Egg Omelette',
        desc: 'Fluffy egg omelette sandwiched between toasted bread slices — a hearty, filling snack.',
        tag: '',
      },
      'omelette-2egg': {
        name: 'Omelette [2 Egg]',
        desc: 'Classic two-egg omelette with onions, green chillies and coriander — served hot and fluffy.',
        tag: '',
      },
      'dahi-bhalla': {
        name: 'Dahi Bhalla',
        desc: 'Soft lentil dumplings soaked in sweet yogurt, topped with tangy tamarind and green chutney.',
        tag: '',
      },
      'bhalla-papdi-chaat': {
        name: 'Bhalla Papdi Chaat',
        desc: 'A loaded chaat with bhalla, crispy papdi, yogurt, chutneys and chickpeas — sweet, sour and spicy.',
        tag: '',
      },
      'dahi-puri': {
        name: 'Dahi Puri',
        desc: 'Crispy hollow puris filled with potatoes, chickpeas, sweet yogurt and chutneys — a burst of flavor.',
        tag: '',
      },
      'pani-puri': {
        name: 'Pani Puri',
        desc: 'The king of chaat — crispy puris filled with spicy tangy water, potatoes and chickpeas.',
        tag: 'Popular',
      },
      'papdi-chaat': {
        name: 'Papdi Chaat',
        desc: 'Crispy flour crackers topped with boiled potatoes, chickpeas, yogurt and tamarind chutney.',
        tag: '',
      },
      'aloo-tikki-chaat': {
        name: 'Aloo Tikki Chaat',
        desc: 'Golden potato patties topped with chickpeas, yogurt, chutneys and crispy sev — crunchy and creamy.',
        tag: '',
      },
      'tikki-chana-chaat': {
        name: 'Tikki Chana Chaat',
        desc: 'Crispy aloo tikki paired with spiced chickpea curry and chutneys — a hearty, filling chaat.',
        tag: '',
      },
      'samosa-chana-chaat': {
        name: 'Samosa Chana Chaat',
        desc: 'Crispy samosa broken into spiced chickpea curry with yogurt and chutneys — a chaat masterpiece.',
        tag: '',
      },
      'aloo-paratha': {
        name: 'Aloo Paratha',
        desc: 'Whole wheat paratha stuffed with spiced mashed potatoes, served with butter and yogurt.',
        tag: '',
      },
      'paneer-paratha': {
        name: 'Paneer Paratha',
        desc: 'Flaky paratha loaded with crumbled paneer, green chillies and coriander — rich and satisfying.',
        tag: '',
      },
      'mix-paratha': {
        name: 'Mix Paratha',
        desc: 'Stuffed paratha with a medley of spiced vegetables — hearty, wholesome and full of flavor.',
        tag: '',
      },
      'poori-bhaji': {
        name: 'Poori Bhaji',
        desc: 'Fluffy deep-fried pooris served with spiced potato curry — a beloved Indian breakfast classic.',
        tag: '',
      },
      'chhole-bhature': {
        name: 'Chhole Bhature',
        desc: 'Punjab-famous fluffy bhaturas with spicy chickpea curry — rich, filling and unforgettable.',
        tag: 'Punjabi Classic',
      },
      'lemon-chicken-pakora': {
        name: 'Lemon Chicken Pakora',
        desc: 'Crispy chicken fritters with a bright lemon zest kick, served with mint chutney.',
        tag: '',
      },
      'chicken-pakora': {
        name: 'Chicken Pakora',
        desc: 'Tender chicken pieces coated in spiced batter and fried crisp — juicy inside, crunchy outside.',
        tag: '',
      },
      'paneer-tikka': {
        name: 'Paneer Tikka',
        desc: 'Marinated cottage cheese cubes grilled in the tandoor with capsicum and onion — smoky and creamy.',
        tag: 'Chef’s Pick',
      },
      'brunt-chilli-paneer': {
        name: 'Brunt Chilli Paneer',
        desc: 'Fiery paneer stir-fried with green chillies, onions and soy sauce — Indo-Chinese at its best.',
        tag: '',
      },
      'brunt-chilli-chicken': {
        name: 'Brunt Chilli Chicken',
        desc: 'Spicy chicken chunks tossed with burnt chillies, garlic and soy — bold, smoky and addictive.',
        tag: '',
      },
      'paneer-65': {
        name: 'Paneer 65',
        desc: 'Deep-fried paneer cubes tossed in a spicy, tangy 65-style sauce with curry leaves and chillies.',
        tag: '',
      },
      'chicken-65': {
        name: 'Chicken 65',
        desc: 'The legendary South Indian starter — crispy chicken in a fiery red 65 masada with curry leaves.',
        tag: 'Popular',
      },
      'chilli-mushroom': {
        name: 'Chilli Mushroom',
        desc: 'Crispy fried mushrooms tossed in spicy chilli sauce with capsicum and onion — tangy and hot.',
        tag: '',
      },
      'plain-papad': {
        name: 'Plain Papad',
        desc: 'Crispy roasted lentil wafers, lightly spiced — the perfect crunchy starter with every meal.',
        tag: '',
      },
      'masala-papad': {
        name: 'Masala Papad',
        desc: 'Crispy papad topped with chopped onions, tomatoes, green chillies and coriander — fresh and zesty.',
        tag: '',
      },
      'peanut-masala': {
        name: 'Peanut Masala',
        desc: 'Roasted peanuts tossed with onions, tomatoes, lemon juice and spices — a crunchy, tangy bar snack.',
        tag: '',
      },
      'fried-masala-chana': {
        name: 'Fried Masala Chana',
        desc: 'Crispy fried chickpeas seasoned with chaat masala and spices — addictive and crunchy.',
        tag: '',
      },
      'cucumber-salad': {
        name: 'Cucumber Salad',
        desc: 'Cool and crunchy cucumber slices with lemon, chaat masala and fresh coriander — refreshing.',
        tag: '',
      },
      'mix-green-salad': {
        name: 'Mix Green Salad',
        desc: 'A vibrant mix of lettuce, cucumber, tomato and onion with a light lemon dressing — light and fresh.',
        tag: '',
      },
      'onion-salad': {
        name: 'Onion Salad',
        desc: 'Thinly sliced onion rings with green chillies, lemon and chaat masada — sharp and tangy.',
        tag: '',
      },
      'fruit-chaat': {
        name: 'Fruit Chaat',
        desc: 'Fresh seasonal fruits tossed with chaat masada, black salt and lemon juice — sweet, sour and spicy.',
        tag: '',
      },
      'french-fries': {
        name: 'French Fries',
        desc: 'Golden, crispy French fries, perfectly salted and served hot — a timeless classic.',
        tag: '',
      },
      'chilli-potato': {
        name: 'Chilli Potato',
        desc: 'Crispy potato wedges tossed in spicy chilli sauce with capsicum and onion — hot and crunchy.',
        tag: '',
      },
      'honey-chilli-fries': {
        name: 'Honey Chilli Fries',
        desc: 'Crispy fries glazed in sweet honey and spicy chilli sauce with sesame seeds — sweet meets heat.',
        tag: '',
      },
      'honey-chilli-cauliflower': {
        name: 'Honey Chilli Cauliflower',
        desc: 'Crispy cauliflower florets in a sticky honey-chilli glaze — crunchy, sweet and fiery.',
        tag: '',
      },
      'aloo-tikki-burger': {
        name: 'Aloo Tikki Burger',
        desc: 'Crispy potato tikki patty in a soft bun with mayo and fresh veggies — a desi twist on a classic.',
        tag: '',
      },
      'cheese-burger': {
        name: 'Cheese Burger',
        desc: 'Juicy patty with melted cheese, fresh lettuce and tomato in a toasted bun — timeless comfort food.',
        tag: '',
      },
      'paneer-burger': {
        name: 'Paneer Burger',
        desc: 'Grilled paneer patty with spicy mayo and crunchy veggies in a soft bun — a veggie favorite.',
        tag: '',
      },
      'chicken-burger': {
        name: 'Chicken Burger',
        desc: 'Grilled chicken patty with fresh lettuce, tomato and mayo in a toasted bun — juicy and satisfying.',
        tag: '',
      },
      'desi-fried-burger': {
        name: 'Desi Fried Burger',
        desc: 'Crispy fried patty loaded with Indian spices, layered with onion and chutney in a desi-style bun.',
        tag: '',
      },
      'veg-maggi': {
        name: 'Veg Maggi',
        desc: 'Classic Maggi noodles tossed with fresh vegetables and desi spices — quick, spicy and nostalgic.',
        tag: '',
      },
      'egg-maggi': {
        name: 'Egg Maggi',
        desc: 'Maggi noodles with scrambled eggs and veggies — a protein-packed twist on a childhood favorite.',
        tag: '',
      },
      'masala-maggi': {
        name: 'Masala Maggi',
        desc: 'Maggi noodles loaded with extra masada, onion, tomato and green chillies — bold and desi.',
        tag: '',
      },
      'momos': {
        name: 'Momos',
        desc: 'Steamed dumplings filled with seasoned vegetables or chicken, served with spicy red chutney.',
        tag: 'Popular',
      },
      'veg-manchurian': {
        name: 'Veg Manchurian',
        desc: 'Crispy vegetable balls in a tangy, spicy Manchurian gravy with garlic and spring onion.',
        tag: '',
      },
      'chicken-manchurian': {
        name: 'Chicken Manchurian',
        desc: 'Fried chicken in a rich, spicy Manchurian sauce with capsicum and onion — a desi-Chinese classic.',
        tag: '',
      },
      'hakka-noodles': {
        name: 'Hakka Noodles',
        desc: 'Stir-fried noodles with crunchy vegetables, soy sauce and desi spices — wok-tossed perfection.',
        tag: '',
      },
      'chicken-noodles': {
        name: 'Chicken Noodles',
        desc: 'Wok-fried noodles with tender chicken strips, vegetables and a smoky soy-chilli glaze.',
        tag: '',
      },
      'indian-chowmin': {
        name: 'Indian Chowmin',
        desc: 'Desi-style chowmein loaded with veggies, egg and spicy sauces — street-style noodles at their best.',
        tag: '',
      },
      'veg-spring-rolls': {
        name: 'Veg Spring Rolls',
        desc: 'Crispy golden rolls stuffed with seasoned vegetables, served with sweet chilli dipping sauce.',
        tag: '',
      },
      'tomato-soup': {
        name: 'Tomato Soup',
        desc: 'Creamy tomato soup with a hint of Indian spices, served hot with crisp croutons on top.',
        tag: '',
      },
      'chicken-manchow-soup': {
        name: 'Chicken Manchow Soup',
        desc: 'Hearty Indo-Chinese soup with shredded chicken, crispy noodles and a bold, spicy broth.',
        tag: '',
      },
      'manchow-soup': {
        name: 'Manchow Soup',
        desc: 'Spicy vegetable Manchow soup topped with crunchy fried noodles — bold, warming and full of flavor.',
        tag: '',
      },
      'hot-n-sour-soup': {
        name: 'Hot N Sour Soup',
        desc: 'A fiery, tangy soup with vegetables, tofu and a kick of black pepper and vinegar — intense and satisfying.',
        tag: '',
      },
      'plain-curd': { name: 'Plain Curd', desc: 'Fresh homemade curd, cool and creamy — the perfect palate cleanser with any spicy meal.', tag: '' },
      // Raita
      'plain-raita': { name: 'Plain Raita', desc: 'Cool and creamy yogurt with cumin and coriander — a refreshing side.', tag: '' },
      'boondi-raita': { name: 'Boondi Raita', desc: 'Crispy gram flour pearls in chilled yogurt with roasted cumin.', tag: '' },
      'mix-raita': { name: 'Mix Raita', desc: 'Loaded raita with cucumber, tomato, onion and boondi — colorful and cooling.', tag: '' },
      // Pizza
      'margarita-pizza': { name: 'Margarita Pizza', desc: 'Classic thin-crust pizza with tomato sauce, fresh mozzarella and basil.', tag: '' },
      'chef-veggie-pizza': { name: 'Chef Special Veggie Pizza', desc: 'Loaded with bell peppers, mushrooms, corn, olives and three cheeses.', tag: "Chef's Pick" },
      'paneer-tikka-pizza': { name: 'Paneer Tikka Pizza', desc: 'Tandoori paneer, onion and capsicum on a cheesy base — a smoky desi twist.', tag: 'Fusion' },
      'chicken-tikka-pizza': { name: 'Chicken Tikka Pizza', desc: 'Smoky chicken tikka, onion rings and chutney on cheesy pizza base.', tag: 'Fusion' },
      'onion-pizza': { name: 'Onion Pizza', desc: 'Caramelized onions, mozzarella and herbs on a thin crispy crust.', tag: '' },
      // Sweets
      'boondi-laddu': { name: 'Boondi Laddu', desc: 'Golden fried gram flour pearls in sugar syrup — melt-in-your-mouth bliss.', tag: '' },
      'khowa-barfi': { name: 'Khowa Barfi', desc: 'Rich milk solids barfi with cardamom fragrance — dense, fudgy and classic.', tag: '' },
      'kaju-katli': { name: 'Kaju Katli', desc: 'Luxurious cashew fudge in diamond slices with silver leaf — smooth and royal.', tag: 'Premium' },
      'besan-barfi': { name: 'Besan Barfi', desc: 'Gram flour barfi roasted in ghee, sweetened and cut in squares — nutty and aromatic.', tag: '' },
      'guliya': { name: 'Guliya', desc: 'Folded pastry pockets with sweetened coconut and nuts — crisp and delicate.', tag: '' },
      'motichur-laddu': { name: 'Motichur Laddu', desc: 'Tiny golden boondi pearls in fragrant sugar syrup — soft and luscious.', tag: '' },
      'milk-cake': { name: 'Milk Cake', desc: 'Caramelized thickened milk cut into rich, grainy squares.', tag: '' },
      'jalebi': { name: 'Jalebi', desc: 'Crispy syrupy spirals soaked in saffron-infused sugar syrup.', tag: 'Popular' },
      'gulab-jamun': { name: 'Gulab Jamun', desc: 'Soft milk solids dumplings soaked in warm rose-scented sugar syrup.', tag: 'Popular' },
      'rasgula': { name: 'Rasgula', desc: 'Soft spongy cottage cheese balls in light sugar syrup — delicate and airy.', tag: '' },
      'boondi-sweet': { name: 'Boondi', desc: 'Tiny golden fried gram flour droplets, crisp and sweetened — for prasad or dessert.', tag: '' },
      'peda': { name: 'Peda', desc: 'Rich milk fudge discs with cardamom and saffron — smooth and deeply satisfying.', tag: '' },
      'rasmalai': { name: 'Rasmalai', desc: 'Paneer discs soaked in saffron-infused milk, garnished with pistachios.', tag: 'Premium' },
      // Main Veg
      'daal-tadka': { name: 'Daal Tadka', desc: 'Yellow lentils tempered with cumin, garlic and red chillies in ghee.', tag: '' },
      'aloo-matter': { name: 'Aloo Matter', desc: 'Potatoes and green peas in tomato-onion gravy — homestyle goodness.', tag: '' },
      'aloo-chhole': { name: 'Aloo Chhole', desc: 'Spiced chickpea curry with tender potato chunks.', tag: '' },
      'zeera-aloo': { name: 'Zeera Aloo', desc: 'Baby potatoes with cumin seeds, turmeric and fresh coriander.', tag: '' },
      'mix-veg-kolapuri': { name: 'Mix Veg Kolapuri Style', desc: 'Vegetables in a fiery Kolhapuri masala gravy with coconut.', tag: 'Spicy' },
      'matter-paneer': { name: 'Matter Paneer', desc: 'Paneer cubes and green peas in rich tomato-cashew gravy.', tag: '' },
      'kadhai-paneer': { name: 'Kadhai Paneer', desc: 'Paneer and capsicum in thick spiced tomato gravy — sizzling hot.', tag: 'Popular' },
      'shahi-paneer': { name: 'Shahi Paneer', desc: 'Royal paneer in silky cream, cashews and aromatic spices.', tag: 'Popular' },
      'paneer-lawabdar': { name: 'Paneer Lawabdar', desc: 'Paneer in a luscious tangy gravy with fenugreek — irresistibly creamy.', tag: '' },
      'adarki-daniya-paneer': { name: 'Adarki Daniya Paneer', desc: 'Paneer in bold ginger-coriander gravy — fresh and zesty.', tag: '' },
      'mushroom-payaja': { name: 'Mushroom Payaja', desc: 'Mushrooms and caramelized onions in creamy spiced gravy.', tag: '' },
      'sev-bhaji': { name: 'Sev Bhaji', desc: 'Crispy sev in spicy tomato-onion gravy with peanuts.', tag: '' },
      'paneer-butter-masala': { name: 'Paneer Butter Masala', desc: 'Paneer in velvety tomato-butter-cream gravy — mildly spiced and heavenly.', tag: 'Best Seller' },
      'makhni-paneer': { name: 'Makhni Paneer', desc: 'Paneer in silky makhani gravy of butter, tomato and cream.', tag: '' },
      'daal-makhni': { name: 'Daal Makhni', desc: 'Black lentils slow-cooked with butter, cream and tomatoes — the Punjabi crown jewel.', tag: 'Best Seller' },
      // Non Veg
      'chicken-rara-masala': { name: 'Chicken Rara Masala', desc: 'Minced chicken and chunks in thick spiced gravy — double texture, double flavor.', tag: '' },
      'kadhai-chicken': { name: 'Kadhai Chicken', desc: 'Chicken and capsicum in thick spiced tomato gravy — bold and sizzling.', tag: 'Popular' },
      'butter-chicken': { name: 'Butter Chicken', desc: 'Tandoori chicken in silky buttery tomato gravy — world-famous.', tag: 'Best Seller' },
      'lemon-chicken-gravy': { name: 'Lemon Chicken Gravy', desc: 'Chicken in a zesty lemon gravy with coriander — bright and refreshing.', tag: '' },
      'chicken-curry': { name: 'Chicken Curry', desc: 'Classic homestyle chicken in rich onion-tomato gravy with whole spices.', tag: '' },
      'egg-curry': { name: 'Egg Curry', desc: 'Hard-boiled eggs in spiced tomato-onion gravy — simple and satisfying.', tag: '' },
      'egg-bhurji': { name: 'Egg Bhurji [2 Egg]', desc: 'Scrambled eggs with onions, tomatoes, chillies and spices.', tag: '' },
      // Rice
      'steamed-rice': { name: 'Steamed Rice', desc: 'Fluffy basmati rice — the perfect companion to any curry.', tag: '' },
      'pea-pulao': { name: 'Pea Pulao Rice', desc: 'Basmati rice with green peas, whole spices and ghee.', tag: '' },
      'zeera-rice': { name: 'Zeera Rice', desc: 'Basmati tempered with cumin seeds and ghee.', tag: '' },
      'veg-fried-rice': { name: 'Veg Fried Rice', desc: 'Wok-tossed rice with vegetables and soy sauce.', tag: '' },
      'egg-fried-rice': { name: 'Egg Fried Rice', desc: 'Fried rice with scrambled eggs and vegetables.', tag: '' },
      'chicken-fried-rice': { name: 'Chicken Fried Rice', desc: 'Wok-fried rice with tender chicken strips and desi spices.', tag: '' },
      'veg-biryani': { name: 'Veg Biryani', desc: 'Layered basmati with spiced vegetables, saffron and fried onions.', tag: '' },
      'chicken-biryani': { name: 'Chicken Biryani', desc: 'Fragrant basmati layered with marinated chicken and saffron.', tag: 'Best Seller' },
      'egg-biryani': { name: 'Egg Biryani', desc: 'Aromatic rice with boiled eggs, whole spices and fried onions.', tag: '' },
      // Breads
      'tawa-roti': { name: 'Tawa Roti', desc: 'Soft whole wheat flatbread on a hot griddle.', tag: '' },
      'tawa-butter-roti': { name: 'Tawa Butter Roti', desc: 'Griddle roti brushed with melted butter.', tag: '' },
      'simple-paratha': { name: 'Simple Paratha', desc: 'Layered whole wheat paratha, flaky and lightly crisp.', tag: '' },
      'tandoori-roti': { name: 'Tandoori Roti', desc: 'Whole wheat bread baked in the tandoor — smoky and rustic.', tag: '' },
      'tandoori-butter-roti': { name: 'Tandoori Butter Roti', desc: 'Smoky tandoori roti finished with melted butter.', tag: '' },
      'plain-naan': { name: 'Plain Naan', desc: 'Soft leavened bread baked in the tandoor.', tag: '' },
      'butter-naan': { name: 'Butter Naan', desc: 'Naan slathered with butter — soft, glossy and irresistible.', tag: 'Popular' },
      'garlic-naan': { name: 'Garlic Naan', desc: 'Buttery naan with roasted garlic and coriander.', tag: 'Popular' },
      'messi-roti': { name: 'Messi Roti', desc: 'Multi-layered flaky roti — buttery and deeply satisfying.', tag: '' },
      'lacha-paratha': { name: 'Lacha Paratha', desc: 'Spiral-layered paratha, crispy outside and soft inside.', tag: '' },
      'onion-kulcha': { name: 'Onion Kulcha', desc: 'Leavened bread stuffed with spiced onions and coriander.', tag: '' },
      'aloo-kulcha': { name: 'Aloo Kulcha', desc: 'Bread stuffed with spiced mashed potatoes.', tag: '' },
      'paneer-kulcha': { name: 'Paneer Kulcha', desc: 'Soft kulcha with crumbled paneer, herbs and green chilli.', tag: '' },
      'mix-kulcha': { name: 'Mix Kulcha', desc: 'Loaded kulcha with paneer, onion and potato stuffing.', tag: '' },
      // Combo
      'daal-rice-combo': { name: 'Daal / Rice', desc: 'Yellow lentil curry with steamed basmati rice.', tag: '' },
      'rajma-rice-combo': { name: 'Rajma / Rice', desc: 'Punjabi kidney bean curry with steamed rice.', tag: '' },
      'chhole-rice-combo': { name: 'Chhole / Rice', desc: 'Spiced chickpea curry with fluffy steamed rice.', tag: '' },
      'kaddi-rice-combo': { name: 'Kaddi / Rice [Sunday Special]', desc: 'Yogurt curry with pakora and steamed rice — Sunday favorite.', tag: 'Special' },
      'daal-churma-combo': { name: 'Daal / Churma [Mehfil Special]', desc: 'Rajasthani feast — five lentils with sweet churma and rice.', tag: 'Mehfil Special' },
      'uttapam-combo': { name: 'Uttapam / Sambar / Chutney', desc: 'Thick South Indian rice pancake with vegetables, sambar and chutney.', tag: '' },
      'dosa-combo': { name: 'Dosa / Sambar / Chutney', desc: 'Crispy rice crepe with lentil sambar and coconut chutney.', tag: '' },
      'masala-dosa-combo': { name: 'Masala Dosa / Sambar / Chutney', desc: 'Crispy dosa stuffed with spiced potato masala.', tag: 'Popular' },
      'vegy-burger-combo': { name: 'Veg Burger / French Fries / Cola', desc: 'Veggie burger, crispy fries and a chilled cola — complete quick meal.', tag: '' },
      'veg-paratha-fries-combo': { name: 'Veg Paratha + French Fries', desc: 'Stuffed paratha with golden French fries — desi meets continental.', tag: '' },
      'paratha-roll-combo': { name: 'Paneer / Chicken Paratha Roll', desc: 'Stuffed paratha roll with paneer or chicken — a handheld desi wrap.', tag: '' },
      'veg-sandwich-club': { name: 'Veg Sandwich Club [Mehfil Special]', desc: 'Triple-decker veg club with cheese, veggies and chutney.', tag: 'Mehfil Special' },
      'chicken-sandwich-club': { name: 'Chicken Sandwich Club [Mehfil Special]', desc: 'Triple-decker chicken club with tandoori chicken and cheese.', tag: 'Mehfil Special' },
    },
  },
  gallery: {
    eyebrow: 'Gallery',
    title: 'Moments Around the Table',
    subtitle: 'Step inside our warm interiors, live-fire tandoor kitchen and vibrant chaat counter.',
    t: {
      g1: 'Warm & inviting interior',
      g2: 'Open flame tandoor kitchen',
      g3: 'Colorful chaat counter',
      g4: 'Fresh spices and herbs',
    },
  },
  hours: {
    eyebrow: 'Opening Hours',
    title: 'We Never Close Our Doors',
    subtitle:
      'Day or night, rain or shine — Mehfil 24/7 is here. Whether you crave breakfast at 3am or a late dinner at midnight, our kitchen and rooftop are always waiting for you.',
    order: 'Order Now',
    map: 'Find Us on Map',
    schedule: 'Weekly Schedule',
    open: 'Open Now',
    open24: 'Open 24 Hours',
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  },
  reviews: {
    eyebrow: 'Reviews',
    title: 'Loved by Our Guests',
    t: {
      t1text:
        'Mehfil is my late-night spot. The paneer tikka is hands down the best in Yerevan, and the fact that they are open 24/7 is a lifesaver.',
      t2text:
        'Ordered the pav bhaji for delivery at 2am and it arrived hot and perfectly packed. The samosa chaat tastes just like Mumbai.',
      t3text:
        'Beautiful atmosphere, friendly staff and incredible mango milkshake. The Indo-Chinese menu here is something you cannot find anywhere else in Yerevan.',
    },
  },
  booking: {
    eyebrow: 'Reservations',
    title: 'Book a Table',
    subtitle:
      'Reserve your spot and send it straight to our WhatsApp — we will confirm your booking right away.',
    name: 'Your Name',
    phone: 'Phone',
    guests: 'Number of Guests',
    date: 'Date',
    time: 'Time',
    note: 'Special requests (optional)',
    send: 'Send Booking via WhatsApp',
    sending: 'Opening WhatsApp…',
  },
  order: {
    eyebrow: 'Takeaway & Delivery',
    title: 'Create an Order',
    subtitle:
      'Build your order, add your details and send everything to our WhatsApp. We confirm and deliver fast.',
    name: 'Your Name',
    phone: 'Phone',
    address: 'Delivery Address',
    note: 'Order notes (optional)',
    send: 'Send Order via WhatsApp',
    sending: 'Opening WhatsApp…',
    empty: 'Your order is empty — add dishes from the menu below.',
    browse: 'Browse the Menu',
    total: 'Total',
  },
  cart: {
    title: 'Your Order',
    empty: 'Your order is empty. Add some dishes from the menu.',
    browse: 'Browse Menu',
    name: 'Your Name',
    phone: 'Phone',
    address: 'Delivery Address',
    note: 'Notes (optional)',
    total: 'Total',
    send: 'Send Order on WhatsApp',
    clear: 'Clear order',
    continue: 'Continue browsing',
    items: 'items',
  },
  info: {
    visit: 'Visit Us',
    call: 'Call Us 24/7',
    open: 'Always Open',
    delivery: 'Delivery',
    address: '28, 1 Rubinyants St, Yerevan 0069, Armenia',
    phone1: '+374 93 951149',
    phone2: '+374 93 951149',
    hours: 'Monday – Sunday, Open 24 Hours',
    deliv: 'Across Yerevan, ~60 minutes',
  },
  footer: {
    desc: 'Authentic Indian cuisine, from tandoor to chaat, served any hour of the day — brought to you by Arman International LLC.',
    links: 'Quick Links',
    touch: 'Get in Touch',
    follow: 'Follow Us',
    about: 'About Us',
    menu: 'Our Menu',
    gallery: 'Gallery',
    contact: 'Contact',
    rights: 'All rights reserved.',
    tagline: 'Open every day, all day.',
    curatedBy: 'Curated by',
  },
};